import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_LIST](state, payload) {
    state.listRules = payload;
  },

  SET_ALERT_ID: (state, payload) => {
    state.alertId = payload._id;
  },

  GET_BRANCH_RULES: (state, payload) => {
    state.branchItems = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/settings/alert-rules/mutations.js